/* ============================================================
   Bolddesignz — native size chart popup
   Used by: snippets/bd-size-chart.liquid
   ============================================================ */
(function () {
  class BDSizeChart extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-bd-sc-modal]');
      this.addEventListener('click', this.onClick.bind(this));
      this.onKeydown = this.onKeydown.bind(this);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    onClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('[data-bd-sc-open]')) {
        event.preventDefault();
        this.open();
      } else if (target.closest('[data-bd-sc-close]')) {
        event.preventDefault();
        this.close();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    open() {
      if (!this.modal) return;
      this.modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  }

  if (!window.customElements.get('bd-size-chart')) {
    window.customElements.define('bd-size-chart', BDSizeChart);
  }
})();
